<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="triangle-skew-spin" [fullScreen]="false">
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <section class="content" id="action6465" style="display: none;">
        <div class="card">
            <div class="card-header text-center">
                <h2>ติดตามแปลงอ้อย</h2>
            </div>
            <div class="card-body">
                <div class="input-group mb-3" [formGroup]="FormTrackCane">
                    <span class="input-group-text">: เลือกเขต/โซน : </span>
                    <select formControlName="seletzone" class="form-control" (change)="GetFarmerList()">
                        <option *ngFor="let item of selectzone" [ngValue]="item.SUPZONE">
                            {{ item.SUPZONE }}
                        </option>
                    </select>
                    <span class="input-group-text">: กรอกรหัสชาวไร่ : </span>
                    <input type="text" class="form-control" formControlName="farmercode" list="farmername">
                    <datalist id="farmername" [hidden]="true" class="form-control">
                        <option *ngFor="let item of farmerlist" [ngValue]="item.FMCODE_B1">
                            {{ item.FMCODE_B1 }} {{ item.fmname }}
                        </option>
                    </datalist>
                    <button class="btn btn-info" (click)="LoaddataTrackCaneLand();">แสดงรายการ</button>
                </div>


                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">รหัสชาวไร่</th>
                            <th scope="col">ชื่อชาวไร่</th>
                            <th scope="col">หมายเลขแปลง</th>
                            <th scope="col">ประเภทอ้อย</th>
                            <th scope="col">พื้นที่</th>
                            <th scope="col">โซน</th>
                            <th scope="col">รูท</th>
                            <th scope="col">นักส่งเสริม</th>
                            <th scope="col">ออกใบติดตาม</th>
                            <!-- <th scope="col">บันทึกกิจกรรม</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of Datacanetrack; index as i">
                            <th scope="row">{{i+1}}</th>
                            <td>{{item.fmcode}}</td>
                            <td>{{item.fmname}}</td>
                            <td>{{item.intLandNo}}</td>
                            <td>{{item.canetype}}</td>
                            <td>{{item.landvalue}}</td>
                            <td>{{item.supzone}}</td>
                            <td>{{item.route}}</td>
                            <td>{{item.supcode}}</td>
                            <td><button class="btn btn-warning"
                                    (click)="GenPDF(item.grade,item.intLandNo,item.canetype,item.landvalue,item.supzone,item.route,item.fmcode,item.ck_hardSoilBlast,item.ck_AmountFertilizer,item.ck_Dolomite,item.ck_AmountNatural,item.ck_GerminationP,item.ck_weed,item.ck_Disease,item.ck_Groove)">ออกเอกสาร</button>
                            </td>
                            <!-- <td><button class="btn btn-info">บันทึกกิจกรรมแปลง</button></td> -->
                    </tbody>
                </table>
            </div>
        </div>

    </section>
    <!-- ติดตามแปลง  -->

    <!-- บันทึกไถเตรียม -->
    <section class="content" id="readygrow" style="display: none;">
        <div class="card">
            <div class="card-body">
                <div class="input-group mb-3" [formGroup]="FormTrackCane">

                    <span class="input-group-text">: เลือกเขต/โซน : </span>
                    <select formControlName="seletzone" class="form-control">
                        <option *ngFor="let item of selectzone" [ngValue]="item.SUPZONE">
                            {{ item.zonecode }}
                        </option>
                    </select>
                    <span class="input-group-text">: เลือกรูท : </span>
                    <input type="text" class="form-control" formControlName="seletroot" pattern="[0-9]"
                        onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))">
                    <button class="btn btn-info" (click)="false">แสดงรายการ</button>
                </div>
                <table class="table">
                    <thead>
                        <th scope="col">ลำดับ</th>
                        <th scope="col">ชื่อชาวไร่</th>
                        <th scope="col">หมายเลขแปลง</th>
                        <th scope="col">ประเภทอ้อย</th>
                        <th scope="col">พื้นที่</th>
                        <th scope="col">ปลูกเสร็จ</th>
                        <th scope="col">ไถเตรียม</th>
                        <th scope="col"> บันทึกไถเตรียม</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><button class="btn btn-outline-info"> บันทึกไถเตรียม</button></td>

                        </tr>
                    </tbody>
                </table>


            </div>
        </div>
    </section>
    <!-- บันทึกไถเตรียม -->

    <!-- เกรดแปลง -->
    <section class="content" id="mytarget" style="display: none;">
        <div class="col-lg-12">
            <div class="card">
                <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3 class="modal-title" id="exampleModalLabel">เงื่อนไขการจับเกรดแปลง พค.64</h3>
                            </div>
                            <div class="modal-body">
                                <p>1. ระเบิดดาน</p>
                                <p>2. ใส่ปุ๋ยเคมี >=50 กก./ไร่</p>
                                <p>3. ใส่ปุ๋ยอินทรีย์ หรือ ไว้ใบ</p>
                                <p>4. ใส่โดโลไมท์</p>
                                <p>5. ไม่มีวัชพืช</p>
                                <p>6. %งอก 100 หรือ =>90 และซ่อมอ้อย</p>
                            </div>

                        </div>
                    </div>
                </div>

                <br>
                <div class="col-sm-6">
                    <div class="input-group md-3" [formGroup]="FormTrackCane">
                        <input class="form-control" type="date" id="today" formControlName="selettime">
                        <button class="btn btn-info" (click)="GetGradePlant();"> แสดงข้อมูล</button>
                        <button type="button" style="float: right;" class="btn btn-primary" data-bs-toggle="modal"
                            data-bs-target="#exampleModal" (click)="showmodal();">
                            เงื่อนไขเกรดแปลง
                        </button>
                    </div>
                </div>



                <div class="card-body">

                    <div class="table-responsive">
                        <table class="table table-head-fixed">
                            <thead id="thead">
                                <tr style="background-color: #39A9DB;">

                                    <th scope="col">ส่วน</th>
                                    <th scope="col">โซน/เขต</th>
                                    <th scope="col">รหัสนักส่งเสริม </th>
                                    <th scope="col">ชื่อนักส่งเสริม </th>
                                    <th scope="col">จำนวนแปลงทั้งหมด </th>
                                    <th scope="col">แปลงเกรด A</th>
                                    <th scope="col">จำนวนไร่</th>
                                    <th scope="col">%แปลง เกรด A</th>
                                    <th scope="col">แปลงเกรด B</th>
                                    <th scope="col">จำนวนไร่</th>
                                    <th scope="col">%แปลง เกรด B</th>
                                    <th scope="col">แปลงเกรด C</th>
                                    <th scope="col">จำนวนไร่</th>
                                    <th scope="col">%แปลง เกรด C</th>
                                </tr>
                            </thead>

                            <tbody id="gradedata" *ngFor="let score of grade">

                                <tr *ngIf="score.Partcode !== 'BRD' && score.supcode!=='Z'">

                                    <td>{{score.Partcode}}</td>
                                    <td>{{score.supzone}}</td>
                                    <td>{{score.supcode}}</td>
                                    <td>{{score.SUPNAME}}</td>
                                    <td>{{score.count_all}}</td>
                                    <td>{{score.gradeA}}</td>
                                    <td>{{score.areaGradeA}}</td>
                                    <td class="text-center"> {{score.pc_gradeA}} %
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar bg-success"
                                                [ngStyle]="{'width': score.pc_gradeA +'%'}">
                                                <span>{{score.pc_gradeA}}% </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">{{score.gradeB}}</td>
                                    <td class="text-center"> {{score.areaGradeB}}</td>
                                    <td class="text-center"> {{score.pc_gradeB}} %
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar bg-success"
                                                [ngStyle]="{'width': score.pc_gradeB +'%'}">
                                                <span>{{score.pc_gradeB}} % </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">{{score.gradeC}}</td>
                                    <td class="text-center"> {{score.areaGradeC}} </td>
                                    <td class="text-center"> {{score.pc_gradeC}} %
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar bg-success"
                                                [ngStyle]="{'width':score.pc_gradeC+'%'}"> {{score.pc_gradeC}} %
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr *ngIf="score.Partcode !== 'BRD' && score.supcode==='Z'"
                                    style="background-color: #ffd56c;">

                                    <td>{{score.Partcode}}</td>
                                    <td>{{score.supzone}}</td>
                                    <td>{{score.supcode}}</td>
                                    <td>{{score.SUPNAME}}</td>
                                    <td>{{score.count_all}}</td>
                                    <td>{{score.gradeA}}</td>
                                    <td>{{score.areaGradeA}}</td>
                                    <td class="text-center"> {{score.pc_gradeA}} %
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar bg-success"
                                                [ngStyle]="{'width':score.pc_gradeA+'%'}">
                                                <span>{{score.pc_gradeA}}% </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">{{score.gradeB}}</td>
                                    <td class="text-center"> {{score.areaGradeB}}</td>
                                    <td class="text-center"> {{score.pc_gradeB}} %
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar bg-success"
                                                [ngStyle]="{'width':score.pc_gradeB+'%'}">
                                                <span>{{score.pc_gradeB}} % </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">{{score.gradeC}}</td>
                                    <td class="text-center"> {{score.areaGradeC}} </td>
                                    <td class="text-center"> {{score.pc_gradeC}} %
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar bg-success"
                                                [ngStyle]="{'width': score.pc_gradeC+'%'}"> {{score.pc_gradeC}} %
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr *ngIf="score.Partcode === 'BRD' && score.supzone==='P'"
                                    style="background-color: #1875ff;">

                                    <td>{{score.Partcode}}</td>
                                    <td>{{score.supzone}}</td>
                                    <td>{{score.supcode}}</td>
                                    <td>{{score.SUPNAME}}</td>
                                    <td>{{score.count_all}}</td>
                                    <td>{{score.gradeA}}</td>
                                    <td>{{score.areaGradeA}}</td>
                                    <td class="text-center"> {{score.pc_gradeA}} %
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar bg-success"
                                                [ngStyle]="{'width': score.pc_gradeA+'%'}">
                                                <span>{{score.pc_gradeA}}% </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">{{score.gradeB}}</td>
                                    <td class="text-center"> {{score.areaGradeB}}</td>
                                    <td class="text-center"> {{score.pc_gradeB}} %
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar bg-success"
                                                [ngStyle]="{'width':score.pc_gradeB+'%'} ">
                                                <span>{{score.pc_gradeB}} % </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">{{score.gradeC}}</td>
                                    <td class="text-center"> {{score.areaGradeC}} </td>
                                    <td class="text-center"> {{score.pc_gradeC}} %
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar bg-success"
                                                [ngStyle]="{'width':score.pc_gradeC+'%'}"> {{score.pc_gradeC}} %
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>


    </section>
    <!-- เกรดแปลง -->


    <!-- กิจกรรมแปลง -->
    <section class="content" id="target" style="display: none;">
        <div class="card" style="display: block; overflow-x:auto;">
            <div class="card-body">
                <!-- <button class="btn btn-info" (click)="GetTarget();"> Refesh/โหลดข้อมูลใหม่ </button> -->
                <div class="row" [formGroup]="FormTrackCane">
                    <div class="col-md-6">
                        <div class="input-group mb-6">
                            <span class="input-group-text" id="basic-addon1">เลือกวันที่ต้องการ</span>
                            <input class="form-control" type="date" id="today" formControlName="selettime">
                            <button class="btn btn-outline-info" (click)="GetTarget();"> แสดงข้อมูล </button>
                        </div>

                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-head-fixed">
                        <thead class="table__head">
                            <tr class="first-col">
                                <th rowspan="1" class="text-center" style="background-color: #39A9DB;">วันที่ </th>
                                <th rowspan="1" class="text-center" style="background-color: #39A9DB; ">{{today}}</th>
                                <th class="text-center" colspan="2" style="background-color: #39A9DB;">พื้นที่</th>
                                <th class="text-center" colspan="2" style="background-color: #39A9DB;">ผลผลิตต่อไร่</th>
                                <th class="text-center" colspan="2" style="background-color: #39A9DB;">ปริมาณอ้อย</th>
                                <th class="text-center" colspan="13" style="background-color: #39A9DB;">กิจกรรมแปลง
                                    (ไร่)</th>
                                <th rowspan="1" class="text-center" colspan="1" style="background-color: #39A9DB;"></th>
                                <th rowspan="1" class="text-center" colspan="1" style="background-color: #39A9DB;"></th>


                            </tr>
                            <tr class="second-col">
                                <th class="text-center" style="background-color: #39A9DB;">นักส่งเสริม</th>
                                <th class="text-center" style="background-color: #39A9DB; ">ประเภท</th>

                                <th class="text-right">ผล</th>
                                <th class="text-right">เป้า</th>
                                <th class="text-right">ประเมิน</th>
                                <th class="text-right">เป้า</th>
                                <th class="text-right">ประเมิน</th>
                                <th class="text-right">เป้าหมาย</th>
                                <th class="text-right">ระเบิดดินดาน</th>
                                <th class="text-right">เคมี 1</th>
                                <th class="text-right">เคมี 2</th>
                                <th class="text-right">ปุ๋ยรอบ 3</th>
                                <th class="text-right">อินทรีย์ + ไว้ใบ</th>
                                <th class="text-right">โดโลไมท์</th>
                                <th class="text-right">ไม่มีวัชพืช</th>

                                <th class="text-right">ระยะร่อง</th>
                                <th class="text-right">ไม่มีโรคแมลง</th>
                                <th class="text-right">ให้น้ำ</th>

                                <th class="text-right"> % งอก</th>
                                <th class="text-right">เกรดแปลง A (ไร่)</th>
                                <th rowspan="1" class="text-center" colspan="1" style="background-color: #39A9DB;">%
                                    ความสำเร็จ</th>
                                <th rowspan="1" class="text-center" colspan="1" style="background-color: #39A9DB;">%
                                    แปลงเกรด A </th>
                                <th class="text-center" colspan="1" style="background-color: #39A9DB;">
                                    การอัพเดตข้อมูลเดือนนี้ </th>

                            </tr>
                        </thead>
                        <tbody *ngFor="let item of actionplanmaindata">
                            <tr *ngIf="item.canetype!==''">
                                <td class="text-center">{{ item.supcode }} | {{ item.SUPNAME }}</td>
                                <td style="text-align: right;">{{ item.canetype }}</td>

                                <td style="text-align: right;">{{ item.sumArea }}</td>
                                <td style="text-align: right;">{{ item.yieldTarget }}</td>
                                <td style="text-align: right;">{{ item.yieldAssess }}</td>
                                <td style="text-align: right;">{{ item.targetCane }}</td>
                                <td style="text-align: right;">{{ item.assessNow }}</td>
                                <td style="text-align: right;">{{ item.sumArea }}</td>
                                <td style="text-align: right;">{{ item.areaH }}</td>
                                <td style="text-align: right;">{{ item.areaC }}</td>
                                <td style="text-align: right;">{{ item.areaC2 }}</td>
                                <td style="text-align: right;">{{ item.areaC3 }}</td>
                                <td style="text-align: right;">{{ item.areaO }}</td>
                                <td style="text-align: right;">{{ item.areaD }} </td>

                                <td style="text-align: right;">{{ item.areaW }}</td>
                                <td style="text-align: right;">{{ item.areaGR }} </td>
                                <td style="text-align: right;">{{ item.areaDI }} </td>
                                <td style="text-align: right;">{{ item.areaWT }}</td>

                                <td style="text-align: right;">{{ item.areaG }} </td>
                                <td style="text-align: right;"> {{ item.areaA }}</td>
                                <td style="text-align: center;">{{ item.pcSuccess }} </td>
                                <td style="text-align: center;">{{ item.pcareaA }}</td>
                                <td style="text-align: center;">{{ item.pcUpdateMonth }} </td>
                            </tr>
                            <tr *ngIf="item.canetype===''" style="background-color: #96E6B3;">
                                <td class="text-center">{{ item.supcode }} | {{ item.SUPNAME }}</td>
                                <td style="text-align: right;">{{ item.canetype }}</td>

                                <td style="text-align: right;">{{ item.sumArea }}</td>
                                <td style="text-align: right;">{{ item.yieldTarget }}</td>
                                <td style="text-align: right;">{{ item.yieldAssess }}</td>
                                <td style="text-align: right;">{{ item.targetCane }}</td>
                                <td style="text-align: right;">{{ item.assessNow }}</td>
                                <td style="text-align: right;">{{ item.sumArea }}</td>
                                <td style="text-align: right;">{{ item.areaH }}</td>
                                <td style="text-align: right;">{{ item.areaC }}</td>
                                <td style="text-align: right;">{{ item.areaC2 }}</td>
                                <td style="text-align: right;">{{ item.areaC3 }}</td>
                                <td style="text-align: right;">{{ item.areaO }}</td>
                                <td style="text-align: right;">{{ item.areaD }} </td>

                                <td style="text-align: right;">{{ item.areaW }}</td>
                                <td style="text-align: right;">{{ item.areaGR }} </td>
                                <td style="text-align: right;">{{ item.areaDI }} </td>
                                <td style="text-align: right;">{{ item.areaWT }}</td>

                                <td style="text-align: right;">{{ item.areaG }} </td>
                                <td style="text-align: right;"> {{ item.areaA }}</td>
                                <td style="text-align: center;">{{ item.pcSuccess }} </td>
                                <td style="text-align: center;">{{ item.pcareaA }}</td>
                                <td style="text-align: center;">{{ item.pcUpdateMonth }} </td>
                            </tr>

                        </tbody>
                        <tbody *ngFor="let item of actionplanallZone">
                            <tr style="background-color: #FFBA08;">
                                <td class="text-center">{{ item.supcode }} | {{ item.SUPNAME }}</td>
                                <td style="text-align: right;">{{ item.canetype }}</td>

                                <td style="text-align: right;">{{ item.sumArea }}</td>
                                <td style="text-align: right;">{{ item.yieldTarget }}</td>
                                <td style="text-align: right;">{{ item.yieldAssess }}</td>
                                <td style="text-align: right;">{{ item.targetCane }}</td>
                                <td style="text-align: right;">{{ item.assessNow }}</td>
                                <td style="text-align: right;">{{ item.sumArea }}</td>
                                <td style="text-align: right;">{{ item.areaH }}</td>
                                <td style="text-align: right;">{{ item.areaC }}</td>
                                <td style="text-align: right;">{{ item.areaC2 }}</td>
                                <td style="text-align: right;">{{ item.areaC3 }}</td>
                                <td style="text-align: right;">{{ item.areaO }}</td>
                                <td style="text-align: right;">{{ item.areaD }} </td>

                                <td style="text-align: right;">{{ item.areaW }}</td>
                                <td style="text-align: right;">{{ item.areaGR }} </td>
                                <td style="text-align: right;">{{ item.areaDI }} </td>
                                <td style="text-align: right;">{{ item.areaWT }}</td>

                                <td style="text-align: right;">{{ item.areaG }} </td>
                                <td style="text-align: right;"> {{ item.areaA }}</td>
                                <td style="text-align: center;">{{ item.pcSuccess }} </td>
                                <td style="text-align: center;">{{ item.pcareaA }}</td>
                                <td style="text-align: center;">{{ item.pcUpdateMonth }} </td>
                            </tr>
                        </tbody>
                        <tbody *ngFor="let item of actionplanallbrd">
                            <tr style="background-color: #3464ff;">
                                <td class="text-center">{{ item.supcode }} | {{ item.SUPNAME }}</td>
                                <td style="text-align: right;">{{ item.canetype }}</td>

                                <td style="text-align: right;">{{ item.sumArea }}</td>
                                <td style="text-align: right;">{{ item.yieldTarget }}</td>
                                <td style="text-align: right;">{{ item.yieldAssess }}</td>
                                <td style="text-align: right;">{{ item.targetCane }}</td>
                                <td style="text-align: right;">{{ item.assessNow }}</td>
                                <td style="text-align: right;">{{ item.sumArea }}</td>
                                <td style="text-align: right;">{{ item.areaH }}</td>
                                <td style="text-align: right;">{{ item.areaC }}</td>
                                <td style="text-align: right;">{{ item.areaC2 }}</td>
                                <td style="text-align: right;">{{ item.areaC3 }}</td>
                                <td style="text-align: right;">{{ item.areaO }}</td>
                                <td style="text-align: right;">{{ item.areaD }} </td>

                                <td style="text-align: right;">{{ item.areaW }}</td>
                                <td style="text-align: right;">{{ item.areaGR }} </td>
                                <td style="text-align: right;">{{ item.areaDI }} </td>
                                <td style="text-align: right;">{{ item.areaWT }}</td>

                                <td style="text-align: right;">{{ item.areaG }} </td>
                                <td style="text-align: right;"> {{ item.areaA }}</td>
                                <td style="text-align: center;">{{ item.pcSuccess }} </td>
                                <td style="text-align: center;">{{ item.pcareaA }}</td>
                                <td style="text-align: center;">{{ item.pcUpdateMonth }} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </section>
    <!-- กิจกรรมแปลง -->


    <!-- แบบฟอร์มบันทึกการสำรวจกิจกรรมแปลง -->
    <section class="content" id="note6465" style="display: block;">
        <div class="col-md-12" id="mapdata">
            <div class="card ">
                <div class="card-header bg-primary">
                    <h3 class="card-title">บันทึกกิจกรรมแปลง</h3>

                    <div class="card-tools">
                        <button type="button " class="btn btn-tool" data-card-widget="collapse"><i
                                class="fas fa-minus"></i>
                        </button>
                    </div>
                    <!-- /.card-tools -->
                </div>
                <!-- /.card-header -->
                <div class="card-body" style="display: block;">
                    <!-- <div class="input-group mb-6" [formGroup]="FormTrackCane">
                        <span class="input-group-text">เลือกปี :</span>
                        <select formControlName="selectyear" class="form-control"
                            (change)="Showdatafromformactionland()">
                            <option value="00" disabled>เลือกปี</option>
                            <option *ngFor="let item of selettimes" [ngValue]="item.year">
                                {{ item.name }}
                            </option>
                        </select>
                        <span class="input-group-text">: เลือกโซน : </span>
                        <select formControlName="seletzone" class="form-control" (change)="getMap()">
                            <option *ngFor="let item of selectzone" [ngValue]="item.SUPZONE">
                                {{ item.SUPZONE }}
                            </option>
                        </select>

                        <input type="text" class="form-control" placeholder="กรอกรูท" formControlName="seletroot"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))">
                        
                        <span class="input-group-text">{{select_root | json}} </span>
                        <span class="input-group-text">: เลือกรูท : </span>
                        <select class="form-control" [(ngModel)]="select_root" [ngModelOptions]="{standalone: true}">
                            <option *ngFor="let item of all_roots" [ngValue]="item">
                                {{ item }}
                            </option>
                        </select>

                        <button class="btn btn-danger" (click)="s_root();" *ngIf="data_map.length>0">ค้นหา</button>

                    </div>-->
                    <div class="row" style="text-align:center" [formGroup]="FormTrackCane">
                        <div class="col"></div>
                        <div class="col-md-2">
                            <mat-form-field appearance="fill">
                                <mat-label>เลือกปี</mat-label>
                                <mat-select disableRipple formControlName="selectyear"
                                    (selectionChange)="Showdatafromformactionland()">
                                    <mat-option value="00" disabled>เลือกปี</mat-option>
                                    <mat-option *ngFor="let item of selettimes" [value]="item.year">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-2">
                            <mat-form-field appearance="fill">
                                <mat-label>เลือกโซน</mat-label>
                                <mat-select disableRipple formControlName="seletzone" (selectionChange)="select_zone()">
                                    <mat-option [value]="" disabled>-- เลือกโซน --</mat-option>
                                    <mat-option *ngFor="let item of selectzone" [value]="item.zone_id">
                                        {{ item.supzone }}-{{ item.zonename }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-progress-bar *ngIf="loading[1]" mode="indeterminate"></mat-progress-bar>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="fill">
                                <mat-label>เลือกรูท</mat-label>
                                <mat-select disableRipple [(ngModel)]="select_root" [disabled]="all_roots.length==0"
                                    [ngModelOptions]="{standalone: true}" multiple>
                                    <mat-checkbox [(ngModel)]="selectAllChecked" [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="toggleSelectAll()">ทุกรูท</mat-checkbox>
                                    <mat-option *ngFor="let item of all_roots; index as i" [value]="item.route">
                                        รูท {{item.route}} มี {{item.cntp|number}} แปลง
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-progress-bar *ngIf="loading[2]" mode="indeterminate"></mat-progress-bar>
                            <!--<div *ngFor="let li of select_root">
                                <label class="container">
                                    {{li}}<span class="badge badge-secondary">
                                        <a class='far fa-edit' style='font-size:24;color:red'
                                            (click)="remove_val(li);"> </a>
                                    </span>
                                </label>
                            </div>-->
                        </div>
                        <div class="col-md-2">
                            <div class="button-row">
                                <button mat-raised-button color="primary" (click)="s_root_1();"
                                    [disabled]="all_roots.length==0">แสดงข้อมูล</button>
                            </div>
                        </div>
                        <div class="col"></div>
                    </div>

                    <div class="card">
                        <agm-map *ngIf="maps.length>0" [streetViewControl]="false" [latitude]="latlong.lat"
                            [longitude]="latlong.long" [zoom]="15" [maxZoom]="30" [minZoom]="10"
                            [fullscreenControl]="true" [locationButton]="true" [mapTypeId]="'hybrid'">
                            <div *ngFor="let item of maps">
                                <agm-marker [latitude]="item.point.lat" [longitude]="item.point.lng"
                                    (markerClick)="selected = item;infordata=item" [label]="item.fmname"
                                    [title]="'แปลง ['+ item.landno +'] ของ ' + item.fmname">
                                    <!-- Tooltip เมื่อเอาเมาส์ชี้ -->
                                    <agm-info-window>
                                        <div style="font-size: 12px; line-height: 1.2; margin: 0; padding: 0;">
                                            <p style="margin: 2px 0;">หมายเลขแปลง: <strong>{{ item.landno }}</strong>
                                            </p>
                                            <p style="margin: 2px 0;">ชื่อชาวไร่: <strong>{{ item.fmname }}</strong></p>
                                            <p style="margin: 2px 0;">พื้นที่: <strong>{{ item.landvalue }}</strong></p>
                                            <p style="margin: 2px 0;">ประเภทอ้อย: <strong>{{ item.CaneTypeName
                                                    }}</strong></p>
                                            <p style="margin: 2px 0;">โซน: <strong>{{ item.ZoneId }}</strong></p>
                                            <p style="margin: 2px 0;">วันที่ปลูก: <strong>{{ item.plantdate | adtob
                                                    }}</strong></p>
                                            <p style="margin: 2px 0;">อายุ: <strong>{{ item.caneage }} วัน</strong></p>
                                        </div>
                                    </agm-info-window>
                                </agm-marker>

                                <agm-polygon *ngIf="item.coordinates" [paths]="item.coordinates"
                                    [strokeColor]="'#44FFD1'" [fillColor]="colorclick">
                                </agm-polygon>
                                <!-- 
                                    <agm-circle *ngif="current" [latitude]="lat" [longitude]="lng" [radius]="50"
                                    [fillColor]="'blue'" [circleDraggable]="false" [editable]="false"></agm-circle>
                                -->
                            </div>
                        </agm-map>

                        <button id="currentlocation" class="btn btn-primary btn-sm" *ngIf="maps.length>0"
                            (click)="currentlocation();">ตำแหน่งปัจจุบัน</button>

                    </div>
                </div>
                <!-- /.card-body -->
            </div>
            <!-- /.card -->
        </div>
        <!-- form infor  -->
        <div class="col-md-12" id="formdata">
            <div class="card border-primary" *ngIf="infordata">
                <div class="card-header text-center bg-warning">แบบฟอร์มบันทึกการสำรวจกิจกรรมแปลง
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                                class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>

                <div class="card-body">
                    <table class="table table-head-fixed table-bordered table-sm">
                        <thead>
                            <tr style="text-align:center">
                                <th scope="col">หมายเลยแปลง</th>
                                <th scope="col">ชื่อชาวไร่</th>
                                <th scope="col">พื้นที่(ไร่)</th>
                                <th scope="col">ประเภทอ้อย</th>
                                <th scope="col">โซน</th>
                                <th scope="col">วันที่ปลูก</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="text-align:center">
                                <td>{{ infordata.landno }}</td>
                                <td>{{ infordata.fmname }}</td>
                                <td>{{ infordata.landvalue }} </td>
                                <td>{{ infordata.CaneTypeName }}</td>
                                <td>{{ infordata.ZoneId }}</td>
                                <td>{{ infordata.PlantDate | adtob }}</td>
                                <td><input type="hidden" value={{infordata.key2}} id="landitid" required /></td>
                                <td><input type="hidden" value={{infordata.landno}} id="landno" required /></td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="table table-head-fixed table-sm" [formGroup]="FormTrackActionLand" style="width:100%">
                        <thead>
                            <tr>
                                <th style="width:20%"></th>
                                <th style="width:25%"></th>
                                <th style="width:20%"></th>
                                <th style="width:25%"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1.วันที่สำรวจแปลง</td>
                                <td><input type="date" name="selectdate" id="selectdate" required
                                        formControlName="selectdate"></td>
                                <td style="color: red;">กรุณาระบุ</td>
                            </tr>
                            <tr>
                                <td>2.ประเมินผลผลิตอ้อย </td>
                                <td><input type="number" name="lookcaneton" id="lookcaneton" min="1" max="40"
                                        maxlength="2" required formControlName="lookcaneton"> ตัน / ไร่</td>
                                <td style="color: red;">กรุณาระบุ</td>
                            </tr>
                            <tr>
                                <td>3.ระยะร่อง </td>
                                <td colspan="2"><input type="number" name="landrate" id="landrate" value="80" min="80"
                                        max="250" formControlName="landrate"> ซม.</td>
                            </tr>
                            <tr>
                                <td>4. % การงอก 0-100 </td>
                                <td colspan="N"><input type="number" name="percenrate" id="percenrate" min="1" max="100"
                                        maxlength="3" formControlName="percenrate"> % </td>
                            </tr>
                            <tr>
                                <td>5. แปลงมีอ้อย </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="exist-yes" class="form-check-input" type="radio" name="Exist"
                                            value="Y" required formControlName="Exist">
                                        <label class="form-check-label" for="exist-yes">มีอ้อย</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="exist-no" class="form-check-input" type="radio" name="Exist"
                                            value="N" required formControlName="Exist">
                                        <label class="form-check-label" for="exist-no">ไม่มีอ้อย</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>6. รูปร่างแปลง </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="areaok-yes" class="form-check-input" type="radio" name="Areaok"
                                            value="Y" required formControlName="Areaok">
                                        <label class="form-check-label" for="areaok-yes">ถูกต้อง</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="areaok-no" class="form-check-input" type="radio" name="Areaok"
                                            value="N" required formControlName="Areaok">
                                        <label class="form-check-label" for="areaok-no">ไม่ถูกต้อง</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>7. พื้นที่เสียหาย </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="damaged-yes" class="form-check-input" type="radio"
                                            name="damaged_area" value="Y" required formControlName="damaged_area">
                                        <label class="form-check-label" for="damaged-yes">มี</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="damaged-no" class="form-check-input" type="radio" name="damaged_area"
                                            value="N" required formControlName="damaged_area">
                                        <label class="form-check-label" for="damaged-no">ไม่มี</label>
                                    </div>
                                </td>
                                <td>
                                    <input type="number" id="damaged_rai" value="0" min="0" max="100"
                                        formControlName="damaged_rai"> ไร่
                                </td>
                            </tr>
                            <tr>
                                <td>8.ระเบิดดาน</td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="dindan-yes" class="form-check-input" type="radio" name="dindan"
                                            value="Y" required formControlName="dindan">
                                        <label class="form-check-label" for="dindan-yes">ทำ</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="dindan-no" class="form-check-input" type="radio" name="dindan"
                                            value="N" required formControlName="dindan">
                                        <label class="form-check-label" for="dindan-no">ไม่ทำ</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="dindanq-yes" class="form-check-input" type="radio" name="dindanQ"
                                            value="Y" required formControlName="dindanQ">
                                        <label class="form-check-label" for="dindanq-yes">คุณภาพ</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="dindanq-no" class="form-check-input" type="radio" name="dindanQ"
                                            value="N" required formControlName="dindanQ">
                                        <label class="form-check-label" for="dindanq-no">ไม่ได้คุณภาพ</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>9.ปุ๋ยรอบ 1 </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee1-yes" class="form-check-input" type="radio" name="cemee1"
                                            value="Y" required formControlName="cemee1">
                                        <label class="form-check-label" for="cemee1-yes">ใส่</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee1-no" class="form-check-input" type="radio" name="cemee1"
                                            value="N" required formControlName="cemee1">
                                        <label class="form-check-label" for="cemee1-no">ไม่ใส่</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee1q-yes" class="form-check-input" type="radio" name="cemee1Q"
                                            value="Y" required formControlName="cemee1Q">
                                        <label class="form-check-label" for="cemee1q-yes">คุณภาพ</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee1q-no" class="form-check-input" type="radio" name="cemee1Q"
                                            value="N" required formControlName="cemee1Q">
                                        <label class="form-check-label" for="cemee1q-no">ไม่ได้คุณภาพ</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>10.ปุ๋ยรอบ 2</td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee2-yes" class="form-check-input" type="radio" name="cemee2"
                                            value="Y" required formControlName="cemee2">
                                        <label class="form-check-label" for="cemee2-yes">ใส่</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee2-no" class="form-check-input" type="radio" name="cemee2"
                                            value="N" required formControlName="cemee2">
                                        <label class="form-check-label" for="cemee2-no">ไม่ใส่</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee2q-yes" class="form-check-input" type="radio" name="cemee2Q"
                                            value="Y" required formControlName="cemee2Q">
                                        <label class="form-check-label" for="cemee2q-yes">คุณภาพ</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee2q-no" class="form-check-input" type="radio" name="cemee2Q"
                                            value="N" required formControlName="cemee2Q">
                                        <label class="form-check-label" for="cemee2q-no">ไม่ได้คุณภาพ</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>11.ปุ๋ยรอบ 3</td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee3-yes" class="form-check-input" type="radio" name="cemee3"
                                            value="Y" required formControlName="cemee3">
                                        <label class="form-check-label" for="cemee3-yes">ใส่</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee3-no" class="form-check-input" type="radio" name="cemee3"
                                            value="N" required formControlName="cemee3">
                                        <label class="form-check-label" for="cemee3-no">ไม่ใส่</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee3q-yes" class="form-check-input" type="radio" name="cemee3Q"
                                            value="Y" required formControlName="cemee3Q">
                                        <label class="form-check-label" for="cemee3q-yes">คุณภาพ</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="cemee3q-no" class="form-check-input" type="radio" name="cemee3Q"
                                            value="N" required formControlName="cemee3Q">
                                        <label class="form-check-label" for="cemee3q-no">ไม่ได้คุณภาพ</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>12.ปุ๋ยอินทรีย์ </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="fertilizeruse-yes" class="form-check-input" type="radio"
                                            name="fertilizeruse" value="Y" required formControlName="fertilizeruse">
                                        <label class="form-check-label" for="fertilizeruse-yes">ใส่</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="fertilizeruse-no" class="form-check-input" type="radio"
                                            name="fertilizeruse" value="N" required formControlName="fertilizeruse">
                                        <label class="form-check-label" for="fertilizeruse-no">ไม่ใส่</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="leaves" class="form-check-input" type="checkbox" name="leaves"
                                            value="H" required formControlName="leaves">
                                        <label class="form-check-label" for="leaves">ไว้ใบ</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="fertilizerq-yes" class="form-check-input" type="radio"
                                            name="fertilizerQ" value="Y" required formControlName="fertilizerQ">
                                        <label class="form-check-label" for="fertilizerq-yes">คุณภาพ</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="fertilizerq-no" class="form-check-input" type="radio"
                                            name="fertilizerQ" value="N" required formControlName="fertilizerQ">
                                        <label class="form-check-label" for="fertilizerq-no">ไม่ได้คุณภาพ</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>13.โดโลไมท์</td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="dolomite-yes" class="form-check-input" type="radio" name="dolomite"
                                            value="Y" required formControlName="dolomite">
                                        <label class="form-check-label" for="dolomite-yes">ใส่</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="dolomite-no" class="form-check-input" type="radio" name="dolomite"
                                            value="N" required formControlName="dolomite">
                                        <label class="form-check-label" for="dolomite-no">ไม่ใส่</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="dolomiteq-yes" class="form-check-input" type="radio" name="dolomiteQ"
                                            value="Y" required formControlName="dolomiteQ">
                                        <label class="form-check-label" for="dolomiteq-yes">คุณภาพ</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="dolomiteq-no" class="form-check-input" type="radio" name="dolomiteQ"
                                            value="N" required formControlName="dolomiteQ">
                                        <label class="form-check-label" for="dolomiteq-no">ไม่ได้คุณภาพ</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>14.วัชพืช</td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="weed-yes" class="form-check-input" type="radio" name="weed" value="Y"
                                            required formControlName="weed">
                                        <label class="form-check-label" for="weed-yes">มี</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="weed-no" class="form-check-input" type="radio" name="weed" value="N"
                                            required formControlName="weed">
                                        <label class="form-check-label" for="weed-no">ไม่มี</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>15. โรค/แมลง </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="bugandgerm-yes" class="form-check-input" type="radio"
                                            name="bugandgerm" value="Y" required formControlName="bugandgerm">
                                        <label class="form-check-label" for="bugandgerm-yes">มี</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="bugandgerm-no" class="form-check-input" type="radio"
                                            name="bugandgerm" value="N" required formControlName="bugandgerm">
                                        <label class="form-check-label" for="bugandgerm-no">ไม่มี</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>16. ให้น้ำ </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input id="takewater-yes" class="form-check-input" type="radio" name="takewater"
                                            value="Y" required formControlName="takewater">
                                        <label class="form-check-label" for="takewater-yes">มี</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input id="takewater-no" class="form-check-input" type="radio" name="takewater"
                                            value="N" required formControlName="takewater">
                                        <label class="form-check-label" for="takewater-no">ไม่มี</label>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>17. ซ่อมอ้อย </td>
                                <td>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" id="repaircane1" name="repaircane"
                                            value="Y" required formControlName="repaircane">
                                        <label class="form-check-label" for="repaircane1"> ซ่อมอ้อย </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" id="repaircane2" name="repaircane"
                                            value="N" required formControlName="repaircane">
                                        <label class="form-check-label" for="repaircane2"> ไม่ซ่อมอ้อย </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <!-- <td *ngIf="orther">3.ข้อแนะนำ(หมายเหตุ)</td> -->
                                <td>18.ข้อแนะนำ(หมายเหตุ)</td>
                                <td><textarea name="comment" id="comment" [value]="" formControlName="comment"
                                        style="width:60%; height: 50%;"></textarea></td>
                                <td style="color: red;">กรุณาระบุ หากไม่มีให้เว้นไว้</td>
                            </tr>
                            <tr>
                                <!-- <td *ngIf="orther">4.รูปภาพประกอบ</td> -->
                                <td>19.รูปภาพประกอบ</td>
                                <td><input type="file" value="text" id="photoland" formControlName="photoland"
                                        (change)="onFileUpload($event.target.files)"></td>
                                <td style="color: red;">หากมีภาพกรุณาอัพโหลด หากไม่มีให้เว้นไว้</td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <div *ngIf="uploadPercentage$ | async as percentage">
                                        <div>อัพโหลดไฟล์ {{percentage}}%</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><button class="btn btn-success" (click)="SubmitData();">บันทึกข้อมูล</button></td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>

        <div class="col-md-12" id="showdata">
            <div class="card ">
                <div class="card-header bg-success" [formGroup]="FormTrackCane">
                    <div class="row">
                        <div class="col-md-4">
                            <h3>รายการบันทึกการสำรวจกิจกรรมแปลง</h3>
                        </div>
                        <div class="col-md-4">
                            <div class="input-group mb-3">
                                <button class="btn btn-sm btn-primary"
                                    (click)="Showdatafromformactionland()">ค้นหารายการ</button>
                            </div>
                        </div>
                    </div>

                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                                class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <mat-form-field>
                        <mat-label>ค้นหา</mat-label>
                        <input matInput (keyup)="Filterby($event)" placeholder="รหัสชาวไร่ ชื่อ โควตา" #input>
                    </mat-form-field>
                    <div class="mat-elevation-z8">
                        <table mat-table [dataSource]="newsql" matSort style="width: 100%;">

                            <ng-container matColumnDef="Daterec">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> วันที่บันทึกข้อมูล </th>
                                <td mat-cell *matCellDef="let element"> {{THtoLocalstring(element.Daterec)}} </td>
                            </ng-container>

                            <ng-container matColumnDef="route">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> รูท </th>
                                <td mat-cell *matCellDef="let element"> {{element.route}} </td>
                            </ng-container>
                            <ng-container matColumnDef="intlandno">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> หมายเลขแปลง </th>
                                <td mat-cell *matCellDef="let element"> {{element.intlandno}} </td>
                            </ng-container>

                            <ng-container matColumnDef="fmcode">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> รหัสชาวไร่ </th>
                                <td mat-cell *matCellDef="let element"> {{element.fmcode}} </td>
                            </ng-container>

                            <ng-container matColumnDef="fmname">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ชื่อ - สกุล </th>
                                <td mat-cell *matCellDef="let element"> {{element.fmname}} </td>
                            </ng-container>

                            <ng-container matColumnDef="landvalue">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> พื้นที่ </th>
                                <td mat-cell *matCellDef="let element"> {{element.landvalue}} </td>
                            </ng-container>

                            <ng-container matColumnDef="dateaudit">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> วันที่สำรวจแปลง </th>
                                <td mat-cell *matCellDef="let element"> {{element.DateAudit|adtob}} </td>
                            </ng-container>

                            <ng-container matColumnDef="ton1">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ประเมินอ้อย (ตัน) </th>
                                <td mat-cell *matCellDef="let element"> {{element.Ton1}} </td>
                            </ng-container>

                            <ng-container matColumnDef="Comment">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> หมายเหตุ </th>
                                <td mat-cell *matCellDef="let element"> {{element.Comment}} </td>
                            </ng-container>

                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                                <td mat-cell *matCellDef="let element">

                                    <button class="btn" (click)="open_menu(1,element);"><mat-icon
                                            style='font-size:24;color:#001aff'>open_in_new</mat-icon></button>

                                    <button *ngIf="element.filepic.length > 1" class="btn btn-info open-AddImgDialog"
                                        data-toggle="modal" data-target="#photoshow"
                                        (click)="showimg(element.Filepic)"><mat-icon>filter_hdr</mat-icon></button>
                                    <button class="btn btn-danger"
                                        (click)="DeleteformDataid(element.DataId);"><mat-icon>delete_sweep</mat-icon></button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="datacolum; sticky: true;"></tr>
                            <tr mat-row *matRowDef="let element; columns: datacolum"></tr>
                        </table>

                        <mat-paginator [pageSizeOptions]="[5, 10, 25, 50, 100, 500]" showFirstLastButtons
                            aria-label="Select page of periodic elements"></mat-paginator>
                    </div>

                    <!-- <table class="table table-head-fixed">
                        <thead>
                            <th>วันที่บันทึกข้อมูล</th>
                            <th>รูท</th>
                            <th>ชื่อชาวไร่</th>
                            <th>หมายเลขแปลง</th>
                            <th>พื้นที่</th>
                            <th>วันที่สำรวจแปลง</th>
                            <th>ประเมินอ้อย (ตัน)</th>
                            <th>ระยะร่อง</th>
                            <th>ระเบิดดาน</th>
                            <th>เคมี 1</th>
                            <th>เคมี 2</th>
                            <th>เคมี 3</th>
                            <th>โดโลไมท์</th>
                            <th>ปุ๋ยอินทรีย์</th>
                            <th>ซ่อมอ้อย</th>
                            <th>วัชพืช</th>
                            <th>โรคและแมลง</th>
                            <th>ให้น้ำ</th>
                            <th>หมายเหตุ</th>
                            <th>รูปภาพ</th>
                            <th>ลบข้อมูล</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of sqldata">
                                <td>{{item.Daterec}}</td>
                                <td>{{item.route}}</td>
                                <td>{{item.fmname}}</td>
                                <td>{{item.intlandno}}</td>
                                <td>{{item.landvalue}}</td>
                                <td>{{item.dateaudit}}</td>
                                <td>{{item.ton1}}</td>
                                <td>{{item.groove}}</td>
                                <td>{{item.hardSoilBlast}}</td>
                                <td>{{item.chemical1}}</td>
                                <td>{{item.chemical2}}</td>
                                <td>{{item.chemical3}}</td>
                                <td>{{item.dolomite}}</td>
                                <td>{{item.organic}}</td>
                                <td>{{item.canerepair}}</td>
                                <td>{{item.weed}}</td>
                                <td>{{item.insect}}</td>
                                <td>{{item.getwater}}</td>
                                <td>{{item.Comment}}</td>
                                <td><button *ngIf="item.Filepic !==''" class="btn btn-info open-AddImgDialog" data-toggle="modal" data-target="#photoshow" (click)="showimg(item.Filepic)"><mat-icon>filter_hdr</mat-icon></button></td>
                                <td><button class="btn btn-danger" (click)="DeleteformDataid(item.dataid);"><mat-icon>delete_sweep</mat-icon></button></td>
                            </tr>
                        </tbody>
                    </table> -->
                </div>
            </div>
        </div>
        <!-- end form  -->

        <!-- Modal -->
        <div class="modal fade" id="show_data" tabindex="-1" role="dialog" aria-labelledby="ModalLabel"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="ModalLabel">ข้อมูลการประเมินอ้อย </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-sm table-head-fixed" *ngIf="s_itid != null">
                            <thead>
                                <tr>
                                    <th>ชื่อผู้ประเมิน</th>
                                    <td scope="col">{{s_itid.Audit_name}}</td>
                                </tr>
                                <tr>
                                    <th>แปลงอ้อย</th>
                                    <td scope="col">{{s_itid.intlandno}}</td>
                                </tr>
                                <tr>
                                    <th>วันที่บันทึก</th>
                                    <td scope="col">{{THtoLocalstring(s_itid.Daterec)}}</td>
                                </tr>
                                <tr>
                                    <th>วันที่สำรวจแปลง</th>
                                    <td scope="col">{{s_itid.DateAudit | adtob}}</td>
                                </tr>
                                <tr>
                                    <th>ประเมินอ้อย ตัน/ไร่</th>
                                    <td scope="col">{{s_itid.Ton1}}</td>
                                </tr>
                                <tr>
                                    <th>ระยะร่อง</th>
                                    <td scope="col">{{s_itid.Groove}}</td>
                                </tr>
                                <tr>
                                    <th>% การงอก</th>
                                    <td scope="col">{{s_itid.Pccane}}</td>
                                </tr>
                                <tr>
                                    <th>แปลงมีอ้อย</th>
                                    <td scope="col">{{s_itid.exist}}</td>
                                </tr>
                                <tr>
                                    <th>รูปร่างแปลง</th>
                                    <td scope="col">{{s_itid.Areaok}}</td>
                                </tr>
                                <tr>
                                    <th>พื้นที่เสียหาย</th>
                                    <td scope="col">{{s_itid.damaged_area}} - {{s_itid.damaged_rai | number}} ไร่</td>
                                </tr>
                                <tr>
                                    <th>ระเบิดดาน</th>
                                    <td scope="col">{{s_itid.hardSoilBlast}}</td>
                                </tr>
                                <tr>
                                    <th>ปุ๋ย 1</th>
                                    <td scope="col">{{s_itid.chemical1}}</td>
                                </tr>
                                <tr>
                                    <th>ปุ๋ย 2</th>
                                    <td scope="col">{{s_itid.chemical2}}</td>
                                </tr>
                                <tr>
                                    <th>ปุ๋ย 3</th>
                                    <td scope="col">{{s_itid.chemical3}}</td>
                                </tr>
                                <tr>
                                    <th>ปุ๋ยอินทรีย์</th>
                                    <td scope="col">{{s_itid.organic}}</td>
                                </tr>
                                <tr>
                                    <th>โดโลไมท์</th>
                                    <td scope="col">{{s_itid.dolomite}}</td>
                                </tr>
                                <tr>
                                    <th>วัชพืช</th>
                                    <td scope="col">{{s_itid.Weed}}</td>
                                </tr>
                                <tr>
                                    <th>โรค/แมลง</th>
                                    <td scope="col">{{s_itid.insect}}</td>
                                </tr>
                                <tr>
                                    <th>ให้น้ำ</th>
                                    <td scope="col">{{s_itid.getwater}}</td>
                                </tr>
                                <tr>
                                    <th>ซ่อมอ้อย</th>
                                    <td scope="col">{{s_itid.canerepair}}</td>
                                </tr>
                                <tr>
                                    <th>หมายเหตุ</th>
                                    <td scope="col">{{s_itid.Comment}}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="modal-footer">

                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="photoshow" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header bg-info">
                        <h3 class="modal-title" id="exampleModalLabel">ภาพประกอบ</h3>
                    </div>
                    <div class="modal-body">
                        <img id="photourl" width="100%" height="100%">
                    </div>

                </div>
            </div>
        </div>
    </section>
    <!-- แบบฟอร์มบันทึกการสำรวจกิจกรรมแปลง -->


</div>
<app-footer></app-footer>